<script setup lang="ts">
/**
 * Imtihon xonasi va o'qish oynasi: sidebar/topbar yo'q, chalg'ituvchi hech
 * narsa yo'q. Sarlavha va asboblar view ichida (ExamRoomView, ReaderView) —
 * layout faqat fon.
 */
</script>

<template>
  <div class="min-h-screen bg-bg">
    <slot />
  </div>
</template>
